import { render, staticRenderFns } from "./ImovelItem.vue?vue&type=template&id=9e08b18a&"
import script from "./ImovelItem.vue?vue&type=script&lang=js&"
export * from "./ImovelItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports